import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoIntervencion/imprimirTipoIntervencionSanitaria`, method: 'POST', body: values, token: token})
}
